
import { AlertCircle } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

interface DatabaseAlertProps {
  dbError: boolean;
  missingColumns?: string[];
}

export const DatabaseAlert: React.FC<DatabaseAlertProps> = ({ dbError, missingColumns = [] }) => {
  if (!dbError && missingColumns.length === 0) return null;

  return (
    <Alert variant="warning" className="mb-6">
      <AlertCircle className="h-4 w-4" />
      <AlertTitle>Mode simulation</AlertTitle>
      <AlertDescription className="text-sm">
        {missingColumns.length > 0 ? (
          <>
            Certaines fonctionnalités sont disponibles uniquement en mode local car votre base de données 
            n'est pas à jour. {missingColumns.includes('active_markets') && 
            "Les marchés actifs ne seront pas sauvegardés."}
          </>
        ) : (
          "Les modifications sont actuellement en mode simulation et ne seront pas sauvegardées en base de données."
        )}
      </AlertDescription>
    </Alert>
  );
};
